import { Button, SubmitButton } from '@components/ui/Button'
import { SubmitButtonProps } from '@components/ui/Button/SubmitButton'
import styles from './styles.module.scss'

export type AddToCartButtonProps = {
  active: boolean
  onAddToCart: SubmitButtonProps['onClick']
  onOutOfStock: () => void
  handle: string
  label?: string
  isSelectedProductOutOfStock: boolean
  // The colourway hasn't launched yet: the out-of-stock prompt promises an
  // arrival rather than a restock.
  isComingSoon?: boolean
}

function AddToCartButton({
  active,
  label = 'Add to Basket',
  onAddToCart,
  onOutOfStock,
  handle,
  isSelectedProductOutOfStock,
  isComingSoon = false
}: AddToCartButtonProps) {
  return (
    <>
      <div
        id="AddToCartButton"
        className={`addToCartButton-container ${styles.AddToCartButton_container}`}
      >
        {isSelectedProductOutOfStock ? (
          <Button variant="secondary" fullWidth="always" onClick={onOutOfStock}>
            {isComingSoon
              ? 'Notify me when my size arrives'
              : 'Notify me when back in stock'}
          </Button>
        ) : (
          <SubmitButton
            classes={`add-to-cart add-to-cart-${handle} ${styles.AddToCartButton}`}
            onClick={onAddToCart}
            disabled={!active}
            fullWidth="always"
          >
            {label}
          </SubmitButton>
        )}
      </div>
    </>
  )
}

export default AddToCartButton
